export default {
	name: 'heroSection',
	title: 'Hero Section',
	type: 'object',
	fields: [
		{
			name: 'heading',
			title: 'Heading',
			type: 'string',
		},
		{
			name: 'subheading',
			title: 'Sub Heading',
			type: 'text',
		},
		{
			name: 'primaryButtonText',
			title: 'Primary Button Text',
			type: 'string',
		},
		{
			name: 'primaryButtonUrl',
			title: 'Primary Button URL',
			type: 'string',
		},
		{
			name: 'secondaryButtonText',
			title: 'Secondary Button Text',
			type: 'string',
		},
		{
			name: 'secondaryButtonUrl',
			title: 'Secondary Button URL',
			type: 'string',
		},
		{
			name: 'backgroundImage',
			title: 'Background Image',
			type: 'image',
			options: {
				hotspot: true,
			},
		},
	],
};
